import { render, staticRenderFns } from "./StackRouterView.vue?vue&type=template&id=ae730b8e&scoped=true"
import script from "./StackRouterView.vue?vue&type=script&lang=js"
export * from "./StackRouterView.vue?vue&type=script&lang=js"
import style0 from "./StackRouterView.vue?vue&type=style&index=0&id=ae730b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae730b8e",
  null
  
)

export default component.exports